import { Col, Divider, Row, Space } from 'antd';
import { OfferWatchDto } from 'src/dtos';
import { MTag, MButton, MTypography } from 'src/lib';
import { Offer } from 'src/models';
import { Color, Image } from 'src/styles';
import { findOfferClosedDate, isOfferClosed } from 'src/utils';

import * as Styles from './IndicationOfInterestCard.styles';

const IndicationOfInterestCard = ({
  offerWatch,
  offer,
  onCancelIndication,
  onViewOffer,
}: {
  offerWatch: OfferWatchDto;
  offer?: Offer;
  onCancelIndication: (offerWatch: OfferWatchDto) => void;
  onViewOffer: Function;
}) => {
  return (
    <div className={Styles.formCard}>
      <Row justify='space-between'>
        <Col className={Styles.offerLogo}>
          <img alt='offer_logo' src={offer?.logoUrl || Image.DefaultOffering} />
        </Col>
        <Col className={Styles.offerName}>
          <MTypography variant='subtitle1' weight='semibold' color={Color.Gray10}>
            {offer?.name}
          </MTypography>
          <div className={Styles.tagsContainer}>
            {offer && isOfferClosed(offer) && <MTag type='red'>*Closed on {findOfferClosedDate(offer) ?? '-'}</MTag>}
            {offer && !isOfferClosed(offer) && (offer?.isComingSoon || offer?.new) && (
              <MTag type='lightblue'>{offer?.isComingSoon ? 'Coming Soon' : 'New'}</MTag>
            )}
          </div>
        </Col>
      </Row>
      <Divider className={Styles.divider} />
      <Row justify='space-between'>
        <Col>
          <MTypography variant='body2' color={Color.Gray7}>
            Desired Investment Amount
          </MTypography>
          <MTypography variant='body1' weight='bold' color={Color.Gray10}>
            {offerWatch?.investmentRange || 'N/A'}
          </MTypography>
        </Col>
        <Col>
          <Space size={8} direction='horizontal' align='center'>
            {offer?.status === 'ACTIVE' ? null : (
              <MButton type='tertiary' onClick={() => onCancelIndication(offerWatch)}>
                Cancel Indication
              </MButton>
            )}
            <MButton onClick={() => onViewOffer(offer?.id)} type={offer?.status === 'ACTIVE' ? 'primary' : 'secondary'}>
              {offer?.status === 'ACTIVE' ? 'Invest' : 'View Offer'}
            </MButton>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default IndicationOfInterestCard;
